export function fixCreateAdminUsersId(params, json) {
  if (json.phoneNumber !== undefined) {
    return {
      data: {...params.data, id: json.objectId},
    };
  }
  return {
    data: {...params.result, id: json.result.objectId},
  };
}
export function adminUserMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      adminUserId: resource.phoneNumber,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateAdminUserId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}


export function fixGetManyAdminUser(headers,json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      adminUserId: resource.phoneNumber,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function adminUserMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, adminUserId: json.result.phoneNumber},
  };
}